<div class="example-container">
    <app-toolbar [isLoginLayout]="true"></app-toolbar>
    <!-- <div class="testdiv"> -->
        <!-- <main> -->
            <router-outlet></router-outlet>
        <!-- </main> -->
        
    <!-- </div> -->
</div>